// Broward County, FL cities — 2020 US Census population data.
// Used for programmatic /services/:service/:city SEO pages on FAME.
// Population numbers are 2020 decennial census (US Census Bureau).
// Mirrored from FDME — Broward County go-to-market is shared across brands.

export interface CityData {
  slug: string;
  name: string;
  county: 'Broward';
  population: number;
  nearby: [string, string];
  attractions: string;
  zip_codes: string[];
  notable_neighborhoods: string[];
  unique_hook: string;
}

export const CITIES: CityData[] = [
  {
    slug: 'fort-lauderdale',
    name: 'Fort Lauderdale',
    county: 'Broward',
    population: 182760,
    nearby: ['oakland-park', 'pompano-beach'],
    attractions: 'Las Olas Boulevard, Fort Lauderdale Beach, and the historic Stranahan House',
    zip_codes: ['33301', '33304', '33305', '33306', '33308', '33311', '33312', '33315', '33316'],
    notable_neighborhoods: ['Las Olas', 'Victoria Park', 'Coral Ridge', 'Rio Vista', 'Sailboat Bend'],
    unique_hook: 'the Venice of America',
  },
  {
    slug: 'pembroke-pines',
    name: 'Pembroke Pines',
    county: 'Broward',
    population: 171178,
    nearby: ['miramar', 'davie'],
    attractions: 'C. B. Smith Park, Pembroke Lakes Mall, and the Shops at Pembroke Gardens',
    zip_codes: ['33023', '33024', '33025', '33026', '33027', '33028', '33029', '33082'],
    notable_neighborhoods: ['Silver Lakes', 'Pembroke Shores', 'Pembroke Falls', 'SilverLakes', 'Chapel Trail'],
    unique_hook: 'one of the fastest-growing family markets in South Florida',
  },
  {
    slug: 'hollywood',
    name: 'Hollywood',
    county: 'Broward',
    population: 153067,
    nearby: ['fort-lauderdale', 'pembroke-pines'],
    attractions: 'Hollywood Beach Broadwalk, ArtsPark at Young Circle, and the Seminole Hard Rock',
    zip_codes: ['33019', '33020', '33021', '33023', '33024', '33025', '33026', '33027', '33028', '33029'],
    notable_neighborhoods: ['Hollywood Lakes', 'Emerald Hills', 'Hollywood Beach', 'Hollywood Hills', 'Oakwood'],
    unique_hook: 'home of the 2.5-mile oceanfront Broadwalk',
  },
  {
    slug: 'coral-springs',
    name: 'Coral Springs',
    county: 'Broward',
    population: 134394,
    nearby: ['margate', 'tamarac'],
    attractions: 'the Coral Springs Museum of Art, Sawgrass Nature Center, and Mullins Park',
    zip_codes: ['33065', '33067', '33071', '33073', '33075', '33076'],
    notable_neighborhoods: ['Eagle Trace', 'Heron Bay', 'Wyndham Lakes', 'Country Club', 'Westchester'],
    unique_hook: 'one of the most master-planned cities in Florida',
  },
  {
    slug: 'miramar',
    name: 'Miramar',
    county: 'Broward',
    population: 134721,
    nearby: ['pembroke-pines', 'hollywood'],
    attractions: 'Miramar Regional Park, Ansin Sports Complex, and the Miramar Cultural Center',
    zip_codes: ['33023', '33025', '33027', '33029'],
    notable_neighborhoods: ['Historic Miramar', 'Riviera Isles', 'Silver Shores', 'Huntington', 'Vizcaya'],
    unique_hook: 'a diverse commuter hub straddling Broward and Miami-Dade',
  },
  {
    slug: 'pompano-beach',
    name: 'Pompano Beach',
    county: 'Broward',
    population: 112046,
    nearby: ['fort-lauderdale', 'deerfield-beach'],
    attractions: 'the Pompano Beach Fishing Pier, Hillsboro Inlet Lighthouse, and Isle Casino',
    zip_codes: ['33060', '33062', '33063', '33064', '33065', '33066', '33067', '33068', '33069'],
    notable_neighborhoods: ['Cypress Bend', 'Palm Aire', 'Harbor Village', 'Old Pompano', 'Cresthaven'],
    unique_hook: 'known for the oldest fishing pier on the South Florida coast',
  },
  {
    slug: 'davie',
    name: 'Davie',
    county: 'Broward',
    population: 105691,
    nearby: ['plantation', 'pembroke-pines'],
    attractions: 'Flamingo Gardens, the Bergeron Rodeo Grounds, and Nova Southeastern University',
    zip_codes: ['33024', '33025', '33026', '33314', '33317', '33324', '33325', '33326', '33328', '33329', '33330', '33331'],
    notable_neighborhoods: ['Forest Ridge', 'Long Lake Ranches', 'Pine Island Ridge', 'Rolling Hills', 'Shenandoah'],
    unique_hook: 'the western-themed ranch town of South Florida',
  },
  {
    slug: 'sunrise',
    name: 'Sunrise',
    county: 'Broward',
    population: 97335,
    nearby: ['plantation', 'tamarac'],
    attractions: 'Sawgrass Mills mall, the FLA Live Arena, and Markham Park',
    zip_codes: ['33313', '33319', '33322', '33323', '33325', '33326', '33351'],
    notable_neighborhoods: ['Welleby', 'Sawgrass Lakes', 'Sunrise Lakes', 'Bonaventure', 'Plum Bay'],
    unique_hook: 'home of the FLA Live Arena and the nation\'s largest outlet mall',
  },
  {
    slug: 'plantation',
    name: 'Plantation',
    county: 'Broward',
    population: 91750,
    nearby: ['sunrise', 'davie'],
    attractions: 'Plantation Historical Museum, Volunteer Park, and the Westfield Broward mall',
    zip_codes: ['33317', '33322', '33324', '33325', '33388'],
    notable_neighborhoods: ['Plantation Acres', 'Jacaranda', 'Central Park', 'Plantation Isles', 'Country Club Estates'],
    unique_hook: 'a tree-canopied bedroom community minutes from I-595',
  },
  {
    slug: 'deerfield-beach',
    name: 'Deerfield Beach',
    county: 'Broward',
    population: 86859,
    nearby: ['pompano-beach', 'margate'],
    attractions: 'Deerfield Beach International Fishing Pier, Quiet Waters Park, and the Arboretum',
    zip_codes: ['33064', '33441', '33442', '33443'],
    notable_neighborhoods: ['Century Village', 'Cove', 'Deer Creek', 'Waterways', 'Independence Bay'],
    unique_hook: 'the Blue Wave-certified beach town on the Palm Beach County border',
  },
  {
    slug: 'weston',
    name: 'Weston',
    county: 'Broward',
    population: 68107,
    nearby: ['davie', 'sunrise'],
    attractions: 'Markham Park, the Weston Town Center, and Regional Park',
    zip_codes: ['33326', '33327', '33331', '33332'],
    notable_neighborhoods: ['Weston Hills', 'Savanna', 'Windmill Ranch Estates', 'Bonaventure', 'The Ridges'],
    unique_hook: 'consistently ranked one of the safest cities in Florida',
  },
  {
    slug: 'tamarac',
    name: 'Tamarac',
    county: 'Broward',
    population: 71897,
    nearby: ['sunrise', 'coral-springs'],
    attractions: 'Caporella Park, Sunset Point Park, and the Tamarac Community Center',
    zip_codes: ['33309', '33319', '33321', '33351'],
    notable_neighborhoods: ['Woodmont', 'Kings Point', 'Mainlands', 'Lime Bay', 'Westwood'],
    unique_hook: 'a 55-plus friendly community at the center of Broward',
  },
  {
    slug: 'north-lauderdale',
    name: 'North Lauderdale',
    county: 'Broward',
    population: 44794,
    nearby: ['tamarac', 'margate'],
    attractions: 'Broward Community Cultural Park, Boulevard Park, and Hampton Pines Park',
    zip_codes: ['33068', '33319', '33321'],
    notable_neighborhoods: ['Rock Island', 'Broadview Park', 'Kimberly Forest', 'Hampton Pines', 'Silver Lakes'],
    unique_hook: 'a compact, working-family market tucked between Tamarac and Margate',
  },
  {
    slug: 'oakland-park',
    name: 'Oakland Park',
    county: 'Broward',
    population: 44229,
    nearby: ['fort-lauderdale', 'pompano-beach'],
    attractions: 'Jaco Pastorius Park, Easterlin Park, and the Funky Buddha Brewery',
    zip_codes: ['33309', '33311', '33334'],
    notable_neighborhoods: ['Coral Heights', 'Royal Palm', 'Lake Emerald', 'Oakland Lakes', 'Prospect Road'],
    unique_hook: 'the Culinary Arts District on Dixie Highway',
  },
  {
    slug: 'margate',
    name: 'Margate',
    county: 'Broward',
    population: 58796,
    nearby: ['coral-springs', 'north-lauderdale'],
    attractions: 'Calypso Cove Aquatic Facility, Firefighters Park, and the Margate Sports Complex',
    zip_codes: ['33063', '33065', '33066', '33068', '33073', '33093'],
    notable_neighborhoods: ['Oriole Golf', 'Paradise Gardens', 'Holiday Springs', 'Margate Oaks', 'Lakewood'],
    unique_hook: 'one of the oldest planned cities in Broward County',
  },
];

export function getCityBySlug(slug: string): CityData | undefined {
  return CITIES.find((c) => c.slug === slug);
}

export function getCitySlugs(): string[] {
  return CITIES.map((c) => c.slug);
}

export function getNearbyCityData(slugs: string[]): CityData[] {
  return slugs
    .map((s) => getCityBySlug(s))
    .filter((c): c is CityData => !!c);
}
